module.exports = __webpack_public_path__ + "img/197.3542d638.jpg";